const localizers = {
  'loading.msg': () => `Carregando...`,
  'logon.message.msg': () => `É necessária autenticação. Insira um ID de usuário e uma senha válidos.`,
  'logon.button.msg': () => `Logon...`,
  'SASServer.logonError.msg': () => `Não é possível fazer logon no servidor.`,
  'SASServer.genericError.msg': () => `O servidor não pode ser alcançado.`,
}
export default localizers;
